/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCuentaContableEmpresaTicketReembolso } from "api/CuentaContableEmpresa.hook"
import { useCuentaContableCuentaTicketReembolso } from "api/CuentaContable_Cuenta.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { DropdownChangeParams } from "primereact/dropdown"
import { useTranslation } from "react-i18next"

const TicketConfiguracion = ({
  initialPorDefectoTicketsReembolso,
  handleSetTicketReembolso,
}: {
  initialPorDefectoTicketsReembolso?: string
  handleSetTicketReembolso: (newValue: string) => void
}) => {
  const { t } = useTranslation()
  const { cuentasContablesEmpresas: cuentasTicketsReembolsoBase } =
    useCuentaContableCuentaTicketReembolso()
  const {
    cuentasContablesEmpresas: cuentasTicketsReembolso,
    cuentasContablesEmpresasRefetch: refreshListaDeCuentasTicketsReembolso,
  } = useCuentaContableEmpresaTicketReembolso()

  return (
    <div className='tarjeta-configuracion'>
      <div className='tw-flex tw-flex-col tw-gap-2'>
        <div className='tw-text-lg tw-font-medium tw-pb-1 tw-text-shadow-default'>
          {t("config.ticketsTitle")}
        </div>
        <p>{t("config.description")}</p>
        <div className='tw-flex tw-flex-col tw-gap-2 tw-w-full tw-text-shadow-default'>
          <span>{t("config.reimbursementTitle")}</span>
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasTicketsReembolso}
            dropdownValue={initialPorDefectoTicketsReembolso ?? ""}
            onChange={(e: DropdownChangeParams) =>
              handleSetTicketReembolso(e.value)
            }
            listaDeCuentasBase={cuentasTicketsReembolsoBase}
            refreshFetchData={refreshListaDeCuentasTicketsReembolso}
            withCreateCuenta
          />
        </div>
      </div>
    </div>
  )
}

export default TicketConfiguracion
